import styled from "styled-components";
import { MainFrame, MainHeadingColor, MainSentenceWrapper, MainText, GrammarRuleInstruction } from "../../../../../../components/01_config/MainStyles";


const Frame = styled(MainFrame)`
    flex-direction: column;
    // background-color: red;
`

const FrameHeading = styled(MainHeadingColor)`
`

const Icon = styled.img`
    height: 40px;
    margin-top: 10px;
`

const SentenceWrapper = styled(MainSentenceWrapper)`
    flex-direction: row;
    line-height: 1;
    justify-content: center;
`

const Text = styled(MainText)`
    white-space: normal;
    text-align: center;    
`

const BoldWordWrapper = styled.div`
`

const BoldWord = styled(Text)`
    font-weight: bold;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
`

const Instruction = styled(GrammarRuleInstruction)`

`

export { Frame, FrameHeading, Icon, SentenceWrapper, Text, BoldWordWrapper, BoldWord, Instruction  }